// Testimonials data — diverse backpacker community
export const TESTIMONIALS = [
  {
    flag: "🇫🇷",
    name: "Marie L.",
    visa: "WHV 417",
    sector: "Mining",
    location: "Karratha, WA",
    text: "Got hired at BHP within 4 days. The 'PTD missing' flag literally saved my application — I would never have known.",
    rating: 5,
    time: "2 days ago",
  },
  {
    flag: "🇩🇪",
    name: "Lukas M.",
    visa: "WHV 462",
    sector: "Hospitality",
    location: "Sydney, NSW",
    text: "Got 3 callbacks in one week in Bondi. My German CV was unreadable for Aussie recruiters. Total game changer.",
    rating: 5,
    time: "5 hours ago",
  },
  {
    flag: "🇮🇹",
    name: "Giulia R.",
    visa: "WHV 417",
    sector: "Farm",
    location: "Bundaberg, QLD",
    text: "88 days done in record time thanks to the right keywords. Farmers actually called me back this time. Grazie!",
    rating: 5,
    time: "8 hours ago",
  },
  {
    flag: "🇪🇸",
    name: "Diego P.",
    visa: "WHV 462",
    sector: "Construction",
    location: "Brisbane, QLD",
    text: "ATS score 48 → 91 in 30 seconds. Landed a labourer gig in Brissy the same week. Increíble.",
    rating: 5,
    time: "12 hours ago",
  },
  {
    flag: "🇵🇹",
    name: "Sofia C.",
    visa: "WHV 462",
    sector: "Hospitality",
    location: "Melbourne, VIC",
    text: "Finally got the barista job I wanted in Fitzroy. The AI added RSA and Latte Art keywords I had forgotten. Obrigada!",
    rating: 5,
    time: "1 day ago",
  },
  {
    flag: "🇬🇧",
    name: "James W.",
    visa: "WHV 417",
    sector: "Logistics",
    location: "Perth, WA",
    text: "Driving job at WorkPac after 2 days. The cover letter was way better than what I would've written. Cheers!",
    rating: 5,
    time: "3 hours ago",
  },
  {
    flag: "🇫🇷",
    name: "Thomas D.",
    visa: "WHV 417",
    sector: "Mining",
    location: "Mount Isa, QLD",
    text: "Underground mining role at Glencore. The AI flagged I was missing my Coal Board Medical. Got it, applied, hired.",
    rating: 5,
    time: "6 hours ago",
  },
  {
    flag: "🇩🇪",
    name: "Anna H.",
    visa: "WHV 462",
    sector: "Healthcare",
    location: "Adelaide, SA",
    text: "Aged care job in 5 days. The 'available immediately' line + my visa upfront made the difference. Danke!",
    rating: 5,
    time: "1 day ago",
  },
  {
    flag: "🇧🇷",
    name: "Pedro S.",
    visa: "WHV 462",
    sector: "Construction",
    location: "Gold Coast, QLD",
    text: "Was getting silence from 30 applications. With AussieCV — 4 interviews in a week. White Card finally visible!",
    rating: 5,
    time: "9 hours ago",
  },
  {
    flag: "🇮🇹",
    name: "Marco V.",
    visa: "Student 500",
    sector: "Retail",
    location: "Melbourne, VIC",
    text: "Casual job at Coles within 3 days. Loved that I could just paste the Seek URL. Bellissimo.",
    rating: 5,
    time: "14 hours ago",
  },
  {
    flag: "🇪🇸",
    name: "Lucía F.",
    visa: "WHV 417",
    sector: "Farm",
    location: "Mildura, VIC",
    text: "Fruit picking + packing job in Mildura, paid by the bin. Got hired same day. My second year visa is secured!",
    rating: 5,
    time: "2 days ago",
  },
  {
    flag: "🇵🇹",
    name: "Tiago N.",
    visa: "WHV 462",
    sector: "Mining",
    location: "Port Hedland, WA",
    text: "FIFO 2/1 roster at FMG. ATS score went from 35 to 89. The keyword mirror is magic. Worth every minute.",
    rating: 5,
    time: "4 hours ago",
  },
];

// Australian employers backpackers typically apply to.
// `logo` = path to a self-hosted logo in /public/logos/ (100% reliable, no external deps).
// If `logo` is missing, the component falls back to a branded colored badge.
export const EMPLOYERS = [
  { name: "BHP", logo: "/logos/bhp.png", color: "#E84E0F" },
  { name: "Rio Tinto", logo: "/logos/riotinto.png", color: "#C8102E" },
  { name: "Fortescue", logo: "/logos/fortescue.png", color: "#5D2E8C" },
  { name: "WorkPac", logo: "/logos/workpac.png", color: "#00A99D" },
  { name: "Coles", logo: "/logos/coles.png", color: "#E01A22" },
  { name: "Woolworths", logo: "/logos/woolworths.png", color: "#178841" },
  { name: "Programmed", logo: "/logos/programmed.png", color: "#7AB929" },
  { name: "Hays", logo: "/logos/hays.png", color: "#1A1A1A" },
  { name: "Sodexo", logo: "/logos/sodexo.png", color: "#001E62" },
  { name: "Compass Group", logo: "/logos/compass.png", color: "#003DA5" },
  { name: "Spotless", logo: "/logos/spotless.png", color: "#1F6FB5" },
  { name: "Glencore", logo: "/logos/glencore.png", color: "#0070A8" },
  { name: "Roy Hill", logo: "/logos/royhill.webp", color: "#1A1A1A" },
  { name: "Newmont", logo: "/logos/newmont.png", color: "#003B5C" },
  { name: "South32", logo: "/logos/south32.png", color: "#0F2A4D" },
  { name: "Anglo American", logo: "/logos/anglo.png", color: "#0B2545" },
  { name: "Mineral Resources", logo: "/logos/minres.png", color: "#003A70" },
];
